import React from 'react';
import { Box, Typography } from '@material-ui/core';

/**
 * A named, empty page for a navigation destination whose screen is not built yet.
 *
 * WHY THIS EXISTS: the navigation is being built ahead of the pages. Without
 * something to land on, a sidebar item is either missing — which hides the shape
 * of the product from anyone reviewing it — or a dead link, which reads as a bug.
 * This is the third option: the item is present, it navigates, and the page says
 * plainly that it is not ready.
 *
 * It shows the page name and nothing else. No mock cards, no sample numbers, no
 * internal slide codes: a placeholder that looks finished gets demoed and then
 * believed, and design references mean nothing to whoever lands here.
 *
 * @param {string} title  the sidebar label — must match what was clicked
 */
const WorkspacePlaceholder = ({ title }) => (
    <Box style={{ padding: '56px 8px', maxWidth: 720 }}>
        <Typography
            variant="h4"
            style={{
                fontWeight: 700,
                color: 'var(--brand-text, #111827)',
                marginBottom: 10,
            }}
        >
            {title}
        </Typography>

        <Typography
            style={{
                fontSize: 15,
                color: 'var(--brand-text-muted, #6B7280)',
            }}
        >
            Coming soon
        </Typography>
    </Box>
);

export default WorkspacePlaceholder;
